import React, { useState } from "react";
import { Menu, Sun, Moon, Smartphone } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";
import Logo from "./Logo";
import Drawer from "./Drawer";
import AvatarMenu from "./AvatarMenu";
import { NAV } from "../constants/testIds";

export default function TopNav() {
  const [open, setOpen] = useState(false);
  const { theme, toggle, toggleMobile } = useTheme();
  const isDark = theme === "dark";

  return (
    <>
      <header
        data-testid={NAV.topBar}
        style={{
          height: 56,
          background: isDark ? "var(--dnya-mosaic-1)" : "var(--dnya-bg)",
          borderBottom: `1px solid var(--dnya-mosaic-2)`,
          display: "flex",
          alignItems: "center",
          padding: "0 14px",
          position: "fixed",
          top: 0, left: 0, right: 0,
          zIndex: 1000,
          color: "var(--dnya-high-1)",
        }}
      >
        <button
          aria-label="Open menu"
          data-testid={NAV.hamburger}
          onClick={() => setOpen(true)}
          style={{ background: "transparent", border: 0, color: "var(--dnya-high-1)", cursor: "pointer", padding: 8, minWidth: 44, minHeight: 44, display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <Menu size={22} />
        </button>
        <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
          <Logo size={32} />
          <div className="font-dnya" style={{ fontSize: 22, color: "var(--dnya-high-1)" }}>
            Dnya
          </div>
        </div>
        <button
          aria-label="Toggle mobile view"
          data-testid={NAV.mobileToggle}
          onClick={toggleMobile}
          title="Mobile View"
          className="hidden md:inline-flex"
          style={{
            background: "transparent", border: 0, color: "var(--dnya-high-1)", cursor: "pointer",
            padding: 8, minWidth: 44, minHeight: 44,
            alignItems: "center", justifyContent: "center",
          }}
        >
          <Smartphone size={20} />
        </button>
        <button
          aria-label="Toggle theme"
          data-testid={NAV.themeToggle}
          onClick={toggle}
          style={{ background: "transparent", border: 0, color: "var(--dnya-high-1)", cursor: "pointer", padding: 8, minWidth: 44, minHeight: 44, display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          {isDark ? <Sun size={20} /> : <Moon size={20} />}
        </button>
        <AvatarMenu />
      </header>
      <Drawer open={open} onClose={() => setOpen(false)} />
    </>
  );
}
